var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('img',{attrs:{"src":require("@/assets/image/success/bei.png"),"alt":"交卷成功"}}),(_vm.score)?_c('div',[_c('div',{staticClass:"score"},[_vm._v("您的得分："+_vm._s(_vm.score))]),_c('div',{staticClass:"tip"},[_vm._v("此分数仅仅是示意，不能反映真实的作答情况")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }